
$(document).ready(function () {

    $('.ui.form.email-verification')
        .form().submit(function (event) {
            var asda= $('.ui.form.email-verification')
            console.log(asda)
            console.log("asdas")
        })
})
